
const Factory = {

  Meta: {
    'DashboardPage': require( './identity/DashboardPage' ).default,
    'InsightsPage': require( './identity/InsightsPage' ).default,
    'ReportingPage': require( './identity/ReportingPage' ).default,
    'CapacityPage': require( './identity/CapacityPage' ).default,
    'DashboardsPage': require( './identity/DashboardsPage' ).default,
    'CadencesPage': require( './identity/CadencesPage' ).default,
    'ScenariosPage': require( './identity/ScenariosPage' ).default,
    'AutomationPage': require( './identity/AutomationPage' ).default,
    'LinkHealthPage': require( './identity/LinkHealthPage' ).default,
  },

  Data: {

    'Idiom': {

      List: ({ model }) => {

        const Page = require( './domain/IdiomListPage' ).default;
        
        return <Page model={model} />
      },

      Input: ({ model }) => {

        const Page = require( './domain/IdiomInputPage' ).default;

        return <Page model={model} />
      },

      Output: ({ model }) => {

        const Page = require( './domain/IdiomOutputPage' ).default;

        return <Page model={model} />
      },

    },

    'Model': {

      List: ({ model }) => {

        const Page = require( './domain/ModelListPage' ).default;

        return <Page model={model} />
      },

      Input: ({ model }) => {

        const Page = require( './domain/ModelInputPage' ).default;

        return <Page model={model} />
      },

      Output: ({ model }) => {

        const Page = require( './domain/ModelOutputPage' ).default;

        return <Page model={model} />
      },

    }

  },

};



export default Factory;